import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { AssessmentService } from '../shared/services/assessment.service';
import { Assessment } from '../shared/models/assessment';
import { ViewStateService } from '../../shared/services/view-state.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from '../../shared/services/notifications.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: "app-assessment-rules",
  templateUrl: "./assessment-rules.component.html",
  styleUrls: ["./assessment-rules.component.css"],
})
export class AssessmentRulesComponent implements OnInit, OnDestroy {
  personId: string;
  assessment: Assessment;
  assessmentId: string;
  questionId: string;

  onDestroy$ = new Subject();

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private assessmentService: AssessmentService,
    private viewState: ViewStateService,
    private notifications: NotificationsService,
    private authService: AuthService
  ) {
    this.assessment = new Assessment();
  }

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
    this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.assessmentId = params["assessmentId"];
      this.questionId = params["questionId"];
      if (!this.assessmentService.getAssessmentObj(this.assessmentId)) {
        this.viewState.startLoading();
        this.assessmentService
          .getAssessment(this.personId, this.assessmentId)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (assessment) => {
              this.assessment = assessment;
              this.assessmentService.setAssessment(this.assessment);
              this.authService
              .refreshToken()
              .pipe(takeUntil(this.onDestroy$))
              .subscribe();
              this.viewState.stopLoading();
            },
            (errors) => {
              this.handleServerErrorResponse(errors);
            }
          );
      } else {
        this.assessment = this.assessmentService.getAssessmentObj(
          this.assessmentId
        );
      }
    });
  }

  acceptRules() {
    this.startAssessment();
  }

  private startAssessment() {
    this.viewState.startLoading();
    this.assessmentService
      .startAssessment(this.personId, this.assessment.assessmentId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (res) => {
          this.assessmentService.setAssessmentResultId(res.assessmentResultId);
          this.viewState.stopLoading();
          if (res.nextQuestionId) {
            this.router.navigate([
              "assessment/" +
                this.assessmentId +
                "/question/" +
                res.nextQuestionId,
            ]);
          } else {
            this.router.navigate([
              "assessment/" +
                this.assessmentId +
                "/question/" +
                this.assessment.currentQuestionId,
            ]);
          }
        },
        (errors) => {
          this.handleServerErrorResponse(errors);
        }
      );
  }

  private handleServerErrorResponse(response) {
    if (response.status === 500)
      {this.notifications.error(
        "Unexpected Error",
        "An unexpected error occurred. Please try again or contact NBRC for assistance."
      );}
    else {
    }
    this.viewState.stopLoading();
  }

  blockCopy() {
    this.assessmentService
      .warnUser(this.personId, "copy")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        () => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.error(err);
        }
      );
  }

  blockCut() {
    this.assessmentService
      .warnUser(this.personId, "cut")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        () => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );
        },
        (err) => {
          console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
